import React from 'react';
import {useDispatch} from 'react-redux';
import {editCover, setConfirmDeleteMember} from '@om/redux/actions/easiplusFuneralPlan/quote';
import {
    OmLabeledValueSummary,
    OmEfpFamilyMemberCard,
} from '@om/component-library-react';

const EfpFamilyMemberCard = ({
    id,
    relationship,
    age,
    coverAmount,
    monthlyPremium,
    category,
}) => {
    const dispatch = useDispatch();

    return (
        <OmEfpFamilyMemberCard
            expanded
            editEnabled
            deleteEnabled
            addDetailsEnabled
            cardId={id}
            onEditDetailsClicked={() =>
                // TODO: 'All Cover Options' needs to be a type?
                dispatch(editCover(id, category, 'All Cover Options'))
            }
            onPopupModal={() =>
                dispatch(setConfirmDeleteMember({id, relationship, category}))
            }
        >
            <h6
                className="strong small no-top-margin no-bottom-margin"
                slot="family-member-card-heading"
            >
                {relationship}
            </h6>
            <div slot="family-member-card-body">
                <OmLabeledValueSummary
                    label="AGE"
                    value={age}
                />
                <OmLabeledValueSummary
                    label="COVER AMOUNT"
                    value={coverAmount}
                />
                <OmLabeledValueSummary
                    label="MONTHLY PREMIUM"
                    value={monthlyPremium}
                />
            </div>
        </OmEfpFamilyMemberCard>
    );
};

export default EfpFamilyMemberCard;